/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, string, func, shape,
} from 'prop-types';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = () => ({
    saveButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '30px 0',
    },
    button: {
        padding: '6px 20px',
        marginRight: 40,
    },
    customsWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: '30px 0px',
    },
    image: {
        width: '100%',
        height: '100%',
    },
    imageContent: {
        height: '100%',
        width: '45%',
    },
    messageContentParent: {
        width: '45%',
        paddingLeft: '10%',
    },
});
const CUSTOMS_VIEWS = {
    SELECT_IMAGE: 'photo',
    SELECT_MESSAGE: 'text',
    SELECT_IMAGE_AND_MESSAGE: 'both',
};
const ReviewCustom = ({
    classes, addCustomsCard, customsCard, customsCardType, croppedImage, message, dataDictionary,
}) => (
    <>
        <Grid container className={classes.customsWrapper}>
            {CUSTOMS_VIEWS.SELECT_IMAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard}>
                    <img className={classes.image} src={croppedImage} alt="custom" />
                </CustomsCardWrapper>
            )}
            {CUSTOMS_VIEWS.SELECT_MESSAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard}>
                    <div
                        cols="60"
                        rows="8"
                        className={classes.textInsideCard}
                        style={message?.style}
                    >
                        {message?.text}
                    </div>
                </CustomsCardWrapper>
            )}
            {CUSTOMS_VIEWS.SELECT_IMAGE_AND_MESSAGE === customsCardType
            &&            (
                <CustomsCardWrapper customsCard={customsCard}>
                    <Grid container className={classes.messageImageContainer}>
                        <Grid item xs={6} className={classes.imageContent}>
                            <img className={classes.image} src={croppedImage} alt="custom" />
                        </Grid>
                        <Grid item xs={6} className={classes.messageContentParent}>
                            <div
                                cols="60"
                                rows="8"
                                className={classes.textInsideCard}
                                style={message?.style}
                            >
                                {message?.text}
                            </div>
                        </Grid>

                    </Grid>
                </CustomsCardWrapper>
            )}
        </Grid>
        <Grid item xs={12} className={classes.saveButton}>
            <Button variant="contained" color="primary" className={classes.button} onClick={addCustomsCard}>{dataDictionary?.['Add Label'] || 'Add Label'}</Button>
        </Grid>
    </>
);
ReviewCustom.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    addCustomsCard: func.isRequired,
    customsCardType: string.isRequired,
    croppedImage: string.isRequired,
    message: shape({
        messageText: string.isRequired,
    }).isRequired,
    dataDictionary: object,
};
ReviewCustom.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(ReviewCustom);
